const $ = jQuery;
document.addEventListener("DOMContentLoaded", (event) => {
	const teamRow = document.querySelector(".team");

	if (teamRow) {
		const teamMembers = teamRow.querySelectorAll(".et_pb_blurb");

		teamMembers.forEach((member) => {
			const btn = member.querySelector(".read-more-btn");
			const text = member.querySelector(".read-more-text");

			btn?.addEventListener("click", (e) => {
				e.preventDefault();
				member.classList.toggle("is-expanded");

				if (member.classList.contains("is-expanded")) {
					btn.innerHTML = "Collapse";
				} else {
					btn.innerHTML = "Learn More";
				}
			});
		});
	}
});

// read-more-text

// read-more-btn
